var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33342 16.6638V4.33678C3.33342 3.7826 3.7826 3.33342 4.33678 3.33342H13.9954C14.5504 3.33342 14.9996 2.88341 14.9996 2.32923V1.00419C14.9996 0.449178 14.5495 0 13.9954 0H3.36426C1.50671 0 0 1.50671 0 3.36425V17.6363C0 19.4947 1.50671 21.0006 3.36426 21.0006H13.9954C14.5504 21.0006 14.9996 20.5505 14.9996 19.9964V18.6722C14.9996 18.1171 14.5495 17.668 13.9954 17.668H4.33678C3.7826 17.668 3.33342 17.2188 3.33342 16.6646V16.6638Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1888 4.72836L16.2855 5.63172C15.8838 6.0334 15.8838 6.68341 16.2855 7.08509L17.723 8.52263C17.8372 8.6368 17.7563 8.83347 17.5947 8.83347H8.9411C8.37359 8.83347 7.91357 9.29348 7.91357 9.861V11.1385C7.91357 11.706 8.37359 12.1661 8.9411 12.1661H17.5938C17.7555 12.1661 17.8372 12.3619 17.7222 12.4769L16.2846 13.9144C15.883 14.3161 15.883 14.9661 16.2846 15.3678L17.188 16.2712C17.5897 16.6728 18.2397 16.6728 18.6414 16.2712L22.0564 12.8561L23.7082 11.2044C24.0973 10.8152 24.0973 10.1835 23.7082 9.79433L18.6414 4.72753C18.2397 4.32585 17.5897 4.32585 17.188 4.72753L17.1888 4.72836Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.4f920a418ed998ff0f5cd3ef3d0eb9eb.svg";
export { ForwardRef as ReactComponent };